export default __webpack_public_path__ + "static/media/31_2_0.c851c769.png";